






















































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import RevisitApi from '@/api/revisit'
import { TIAN_KONG, DUO_XUAN, DAN_XUAN } from './const'

@Component({})
export default class AddQuestion extends Vue {
	private current = 1
	private pageSize = 10
	private total = 100
	private visible = false
	private searchStr = ''
	private searchResult: any[] = []
	private checkedValues: string[] = []
	private checkedList: any[] = []
	private TIAN_KONG = TIAN_KONG
	private DUO_XUAN = DUO_XUAN
	private DAN_XUAN = DAN_XUAN

	@Prop({})
	private defaultQuestions!: any[]

	@Watch('defaultQuestions', { immediate: true })
	private onDefaultChange() {
		if (this.defaultQuestions && this.defaultQuestions.length > 0) {
			this.checkedValues = this.defaultQuestions.map(
				(question: any) => question.questionId
			)
			this.checkedList = [...this.defaultQuestions]
		}
	}

	@Watch('visible', { immediate: true })
	private onVisibleChange() {
		if (this.visible) {
			this.getList()
		}
	}

	private onChange(e: any, question: any) {
		const checked = e.target.checked
		if (checked) {
			this.checkedValues.push(question.questionId)
			this.checkedList.push(question)
		} else if (!checked) {
			this.checkedValues = this.checkedValues.filter(
				(id: string) => id !== question.questionId
			)
			this.checkedList = this.checkedList.filter(
				(item: any) => item.questionId !== question.questionId
			)
		}
	}

	private onCheck(e: Event) {
		// 避免选中时展示折叠面板
		e.stopPropagation()
	}

	private onPaginationChange(current: number, pageSize: number) {
		this.current = current
		this.pageSize = pageSize
		this.getList()
	}

	private onSearch() {
		this.getList()
	}

	private getList() {
		RevisitApi.getQuestionList({
			question: this.searchStr,
			pageNum: this.current,
			pageSize: this.pageSize,
		}).then((res: any) => {
			this.total = res.data.count
			this.searchResult = res.data.retList
		})
	}

	private onSave() {
		this.$emit('addQuestion', this.checkedList)
		this.visible = false
	}
}
